import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
/**
 * Features component
 */
export class FeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
